import type { ButtonHTMLAttributes } from 'react'
import { cn } from '../../lib/cn.ts'

export type ButtonVariant = 'default' | 'primary' | 'ghost'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: 'md' | 'sm'
}

const VARIANTS: Record<ButtonVariant, string> = {
  default: 'border-border-strong bg-surface text-text hover:bg-surface-2',
  primary:
    'border-accent bg-accent text-accent-ink hover:border-accent-hover hover:bg-accent-hover',
  ghost: 'border-transparent bg-transparent text-muted hover:bg-surface-2 hover:text-text',
}

export function buttonClass(variant: ButtonVariant = 'default', size: 'md' | 'sm' = 'md') {
  return cn(
    'inline-flex shrink-0 items-center justify-center gap-1.5 rounded-ctl border font-medium whitespace-nowrap',
    'transition-colors disabled:cursor-not-allowed disabled:opacity-50 [&_svg]:shrink-0',
    size === 'sm' ? 'h-7 px-2.5 text-[13px]' : 'h-8.5 px-3.5 text-sm',
    VARIANTS[variant],
  )
}

export function Button({ variant, size, className, type = 'button', ...rest }: ButtonProps) {
  return <button type={type} className={cn(buttonClass(variant, size), className)} {...rest} />
}
